export function getQueryStringValue(key) {
  return new URLSearchParams(window.location.search).get(key);
}



// WEBPACK FOOTER //
// ./src/app/helpers/queryString.js